/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GmpTransferAdapter,
  GmpTransferAdapterInterface,
} from "../GmpTransferAdapter";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IBridge",
        name: "bridge",
        type: "address",
      },
      {
        internalType: "address",
        name: "newGmpAddress",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CallerNotAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedFundsTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedRefund",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "InsufficientMsgValueAmount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handler",
        type: "address",
      },
    ],
    name: "InvalidHandler",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "adapter",
        type: "address",
      },
    ],
    name: "InvalidOriginAdapter",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawal",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_bridge",
    outputs: [
      {
        internalType: "contract IBridge",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_resourceID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "crossChainTokenPairs",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "recipientAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "XERC20Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "gmpAdapter",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "address",
        name: "XERC20Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sourceTokenAddress",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "destinationTokenAddress",
        type: "address",
      },
    ],
    name: "setTokenPairAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipientAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "XERC20Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "bridgingAmount",
        type: "uint256",
      },
    ],
    name: "prepareDepositData",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type GmpTransferAdapterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GmpTransferAdapterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GmpTransferAdapter__factory extends ContractFactory {
  constructor(...args: GmpTransferAdapterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GmpTransferAdapter";
  }

  deploy(
    bridge: string,
    newGmpAddress: string,
    resourceID: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GmpTransferAdapter> {
    return super.deploy(
      bridge,
      newGmpAddress,
      resourceID,
      overrides || {}
    ) as Promise<GmpTransferAdapter>;
  }
  getDeployTransaction(
    bridge: string,
    newGmpAddress: string,
    resourceID: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridge,
      newGmpAddress,
      resourceID,
      overrides || {}
    );
  }
  attach(address: string): GmpTransferAdapter {
    return super.attach(address) as GmpTransferAdapter;
  }
  connect(signer: Signer): GmpTransferAdapter__factory {
    return super.connect(signer) as GmpTransferAdapter__factory;
  }
  static readonly contractName: "GmpTransferAdapter";
  public readonly contractName: "GmpTransferAdapter";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GmpTransferAdapterInterface {
    return new utils.Interface(_abi) as GmpTransferAdapterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GmpTransferAdapter {
    return new Contract(address, _abi, signerOrProvider) as GmpTransferAdapter;
  }
}
